export default __webpack_public_path__ + "static/media/um.14abad61.svg";